export const convertUrlUploadProduct = (code_product) => {
  let url = "";
  if (code_product == 1) {
    url = `${process.env.REACT_APP_BASE_API_URL}upload/smartphone`;
  } else if (code_product == 2) {
    url = `${process.env.REACT_APP_BASE_API_URL}upload/car`;
  } else if (code_product == 3) {
    url = `${process.env.REACT_APP_BASE_API_URL}upload/bike`;
  }
  return url;
};

export const convertCodeProduct = (code_product) => {
  let url = "";
  if (code_product == 1) {
    url = `smartphone`;
  } else if (code_product == 2) {
    url = `mobil`;
  } else if (code_product == 3) {
    url = `sepede_motor`;
  }
  return url;
};
